import { Component } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { Goal } from '../../_interfaces/goal.interface';
import { UserPreview } from 'src/app/shared/interfaces/user-preview.interface';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
  selector: 'app-goals-input-feedback',
  templateUrl: './goals-input-feedback.page.html'
})
export class GoalsInputFeedbackPage extends BaseClass {

  public rejectedGoals: Array<Goal> = [];
  public manager: UserPreview;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _modalController: ModalController,
    private _navParams: NavParams
  ) {
    super(_toastController, _translationService);
    this.rejectedGoals = this._navParams.get('goals');
    this.manager = this._navParams.get('manager');
  }

  dismiss() {
    this._modalController.dismiss();
  }
}
